export enum NetworkSecurityInternetIncidentActions {
    FETCH_VIEW = 'FETCH_VIEW',
    CREATE_TICKET = 'CREATE_TICKET',
}
